import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/a4544b0a4d9f1bf04e5ac8f01ed150e8.jpg')`
      }}
    >
      <div className="container mx-auto px-4 w-full">
        <div className="max-w-2xl text-white">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Transform Your Home with <strong>Expert Remodeling</strong>
          </h2>
          <p className="text-xl mb-8 text-gray-200">
            Professional home renovation services in Chicago, IL. From kitchen remodeling to complete home makeovers, we bring your vision to life with quality craftsmanship and seamless project management.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              onClick={() => scrollToSection('quote')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Get Free Quote
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('portfolio')}
              className="border-white text-white hover:bg-white hover:text-gray-900"
            >
              View Our Work
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
